import React from "react";
import "./NftWinners.scss";

const NftWinners = () => {
  const rafflePrizes = [
    {
      label: "1st",
      prize: "1,000,000",
      winner: "0x5A3A3B........73C77442",
    },
    {
      label: "2nd",
      prize: "250,000",
      winner: "0x866c5F........e17c043A",
    },
    {
      label: "3rd",
      prize: "100,000",
      winner: "0xFa5550........316987D6",
    },
  ];

  return (
    <div className="prizes">
      {rafflePrizes.map((prize, pn) => {
        return (
          <div
            className="prize-wrapper bg-hexagon"
            key={`${prize.label}-${pn}`}>
                <h2 className="position">{prize.label}</h2>
                <div className="winner active">
                    <span>{prize.winner}</span>
                </div>
                <span className="prize">
                    <h3 className="value">{prize.prize}</h3>
                    COTI
                </span>
          </div>
        );
      })}
    </div>
  );
};

export default NftWinners;
